const { convertStructuredToUnstructured } = require('./src/addressConversion');

module.exports = { convertStructuredToUnstructured };
